import Component from "react-pure-render/component";
import React, { PropTypes } from "react";
import Modal from "../components/modal.react";
import InputWithError from "../components/inputWithError.react";
import { addNotificationsForInvalidFields } from "../lib/validationWeb";

export default class AddField extends Component {
  addField = () => {
    const {
      actions,
      sectionUID,
      notificationSystem,
      addFieldFormProps,
      objectUID,
      afterAddSuccessAction,
      addDataObjectUID
    } = this.props;
    let data = addFieldFormProps.form.getIn(["fields"]).toJS();
    data.objectUID = addDataObjectUID ? addDataObjectUID : objectUID;
    data.value = "";
    actions.createSectionField(data, sectionUID).then(({ error, payload }) => {
      if (error) {
        addNotificationsForInvalidFields(payload, notificationSystem);
      } else {
        afterAddSuccessAction(objectUID);
      }
    });
    actions.setIsAddFieldModalVisible(false);
  };

  openAddFieldModal = () => {
    const { actions, sectionUID } = this.props;
    actions.setIsAddFieldModalVisible(sectionUID);
  };

  closeAddFieldModal = () => {
    const { actions, sectionUID } = this.props;
    actions.setIsAddFieldModalVisible(false);
  };

  render() {
    const { isAddModalVisible, sectionUID, addFieldFormProps } = this.props;

    return (
      <div className="col-xs-12">
        <button className="info" onClick={this.openAddFieldModal}>
          Dodaj pole
        </button>
        {isAddModalVisible === sectionUID && (
          <Modal
            closeModalAction={this.closeAddFieldModal}
            enterAction={this.addField}
            handleKeyDownEvent={true}
          >
            <div className="row center-xs middle-xs">
              <h3 className="col-xs-12">Dodaj pole</h3>
              <form className="col-xs-12">
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Nazwa pola</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError {...addFieldFormProps} field="name" />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Typ pola</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError {...addFieldFormProps} field="fieldType" />
                  </div>
                </div>
                <div className="row middle-xs">
                  <label className="col-xs-12 col-sm-4">Placeholder</label>
                  <div className="col-xs-12 col-sm-8">
                    <InputWithError
                      {...addFieldFormProps}
                      field="placeholder"
                    />
                  </div>
                </div>
              </form>
              <div className="col-xs-12">
                <button className="info" onClick={this.addField}>
                  Dodaj
                </button>
                <button className="info" onClick={this.closeAddFieldModal}>
                  Anuluj
                </button>
              </div>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/browser/field/addField.react.js